import CRUDHelper from '../../services/CRUDHelper';

class UserMobileNumberStore extends CRUDHelper {
  async verifyUserMobileNumber (userId, userMobileNumberId) {
    let response = await fetch(
      `/api/v4/users/${userId}/user_mobile_numbers/${userMobileNumberId}/verify`, {
        body: new FormData(document.getElementById('form-card')),
        method: 'PATCH'
      });

    return response.json();
  }

  async resendVerificationCode (userId, userMobileNumberId) {
    let response = await fetch(
      `/api/v4/users/${userId}/user_mobile_numbers/${userMobileNumberId}/send_verification_code`, {
        method: 'PATCH'
      });

    return response.json();
  }
};

export default new UserMobileNumberStore('user_mobile_number');
